module.exports = __webpack_public_path__ + "static/media/CheckRequestMegawideLogo.94321f79.png";